export default "__VITE_ASSET__CYKrR3fb__"